import { render, staticRenderFns } from "./delete-per.vue?vue&type=template&id=8b117ac8"
import script from "./delete-per.vue?vue&type=script&lang=js"
export * from "./delete-per.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports